import { apiClient } from './';

export interface IntegrationQueryDoc {
  name: string;
  required: boolean;
  description: string;
}

export interface IntegrationEndpoint {
  id: string;
  method: 'GET' | 'POST';
  path: string;
  scope: string;
  title: string;
  description: string;
  auth: string;
  query: IntegrationQueryDoc[];
  body?: IntegrationQueryDoc[];
  pathParams?: IntegrationQueryDoc[];
}

export interface IntegrationCatalog {
  auth: string;
  scopes: string[];
  endpoints: IntegrationEndpoint[];
}

export interface IntegrationApiKey {
  id: string;
  name: string;
  keyPrefix: string;
  scopes: string[];
  status: 'active' | 'revoked';
  createdBy?: { id: string; name?: string } | null;
  createdAt?: string;
  updatedAt?: string;
  revokedAt?: string | null;
  lastUsedAt?: string | null;
  apiKey?: string;
}

export const getIntegrationCatalog = async () => {
  return apiClient.get<IntegrationCatalog>('/admin/v1/integration/catalog');
};

export const getIntegrationApiKeys = async () => {
  return apiClient.get<IntegrationApiKey[]>('/admin/v1/integration/keys');
};

export const createIntegrationApiKey = async (body: { name: string; scopes?: string[] }) => {
  return apiClient.post<IntegrationApiKey>('/admin/v1/integration/keys', body);
};

export const rotateIntegrationApiKey = async (id: string) => {
  return apiClient.post<IntegrationApiKey>(`/admin/v1/integration/keys/${id}/rotate`);
};

export const revokeIntegrationApiKey = async (id: string) => {
  return apiClient.post<IntegrationApiKey>(`/admin/v1/integration/keys/${id}/revoke`);
};
